/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_Intro_TitleInputs */

const es_marketplace_seo_spain_guide_intro_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquiler de veleros y barcos a motor en España`)
};

const gl_marketplace_seo_spain_guide_intro_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugueiro de veleiros e barcos a motor en España`)
};

const en_marketplace_seo_spain_guide_intro_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sailboat and motorboat rental in Spain`)
};

/**
* | output |
* | --- |
* | "Sailboat and motorboat rental in Spain" |
*
* @param {Marketplace_Seo_Spain_Guide_Intro_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_intro_title = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_Intro_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_Intro_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_intro_title(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_intro_title(inputs)
	return es_marketplace_seo_spain_guide_intro_title(inputs)
});